<template>
  <router-link :to="{ name: 'Home' }" class="logo">
    <div class="disc">
      <div class="disc__half -blue"></div>
      <div class="disc__half -red"></div>
      <div class="disc__line"></div>
      <div class="disc__center">
        <div class="disc__center -inside"></div>
      </div>
    </div>
    <div v-if="!withoutText" class="label">{{ getTranslation(18) }}</div>
  </router-link>
</template>

<script>
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "LogoComponent",
  props: {
    withoutText: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    getTranslation(id) {
      return getTranslation(id);
    },
  },
};
</script>

<style lang="scss" scoped>
$size: 44px;
$padding: 2px;
$border-radius: calc(($size - 2 * $padding) / 2);

.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  background: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $white;
  text-align: center;
  line-height: 1;
}

.disc {
  position: relative;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.5);
  background: $white;
  width: $size;
  height: $size;
  border-radius: 50%;
  padding: $padding;
  text-align: center;

  &__half {
    width: 100%;
    height: 50%;
    border-radius: $border-radius $border-radius 0 0;
    background: $light-blue;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    border: none;
    font-size: 20px;
    line-height: 1.2;

    &.-red {
      background: $red;
      border-radius: 0 0 $border-radius $border-radius;
      color: $white;
    }
  }

  &__line,
  &__center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__line {
    background: $white;
    width: 100%;
    height: $padding;
  }

  &__center {
    width: calc($size / 4.3);
    height: calc($size / 4.3);
    background: $white;
    border-radius: 50%;

    &.-inside {
      width: calc($size / 5);
      height: calc($size / 5);
    }
  }
}

.label {
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.55);
  font-size: 16px;
}
</style>
